export default function BlogCardDescription({ description }) {
    return (
        <p style={{
            fontSize: '14px',
            color: 'var(--rd-text-muted)',
            lineHeight: 1.6,
            margin: '8px 0',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
        }}>
            {description}
        </p>
    );
}
